import { render, staticRenderFns } from "./Tribunes.vue?vue&type=template&id=91f6f1ba&"
import script from "./Tribunes.vue?vue&type=script&lang=js&"
export * from "./Tribunes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports